import { __assign, __awaiter, __generator } from "tslib";
import { isWecom } from '../../config';
import { GET_VIP_ALL, USER_FLAG, USER_INFO, USER_INFO_CHECK, } from './cgi-path';
import { networkRequest } from '@tencent/ark-request';
import { COMMON_COOKIES_KEYS, getCookieByCommonKey } from '@tencent/ark-utils/lib/cookie';
import { addURLParameters } from '@tencent/ark-utils/lib/url';
import { wdocsUserCenter } from '@tencent/wdocs-user-center';
var UserInfoRepository = /** @class */ (function () {
    function UserInfoRepository() {
    }
    UserInfoRepository.prototype.getUserInfo = function (getVipInfo, u) {
        return __awaiter(this, void 0, void 0, function () {
            var paramObj, url;
            return __generator(this, function (_a) {
                // b端复用usercenter的结果不额外请求
                if (isWecom()) {
                    return [2 /*return*/, new Promise(function (resolve) {
                            wdocsUserCenter.getUserInfo().then(function (user) {
                                resolve({
                                    data: user,
                                    status: 200,
                                    statusText: '',
                                });
                            });
                        })];
                }
                paramObj = {
                    get_vip_info: getVipInfo,
                };
                if (u) {
                    paramObj = __assign(__assign({}, paramObj), { u: u });
                }
                url = addURLParameters(USER_INFO, paramObj);
                return [2 /*return*/, networkRequest.post(url, {
                        xsrf: getCookieByCommonKey(COMMON_COOKIES_KEYS.xsrf),
                    })];
            });
        });
    };
    UserInfoRepository.prototype.getVipInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                url = addURLParameters(GET_VIP_ALL, { xsrf: "".concat(getCookieByCommonKey(COMMON_COOKIES_KEYS.xsrf)) });
                return [2 /*return*/, networkRequest.post(url)];
            });
        });
    };
    UserInfoRepository.prototype.getUserFlag = function (type) {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                url = addURLParameters(USER_FLAG, { xsrf: "".concat(getCookieByCommonKey(COMMON_COOKIES_KEYS.xsrf)), type: type });
                return [2 /*return*/, networkRequest.post(url)];
            });
        });
    };
    UserInfoRepository.prototype.userInfoCheck = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                url = addURLParameters(USER_INFO_CHECK, { xsrf: "".concat(getCookieByCommonKey(COMMON_COOKIES_KEYS.xsrf)) });
                return [2 /*return*/, networkRequest.post(url)];
            });
        });
    };
    return UserInfoRepository;
}());
export { UserInfoRepository };
